import axios from 'axios'
import { DateTime } from "luxon"

export function fetchGrowingSeasons() {
  return (dispatch, getState) => {
    dispatch({
      type: 'GROWING_SEASONS_FETCH',
      payload: axios(`/members/growing_seasons`)
    })
  }
}

export function createGrowingSeason(createParams) {
  return async (dispatch, getState) => {
    const response = await axios.post(`/members/growing_seasons`, createParams)
    dispatch(fetchGrowingSeasons())
    return response
  }
}

export function updateGrowingSeason(id, updateParams) {
  return async (dispatch, getState) => {
    dispatch(markGrowingSeasonUpdating(id))

    const response = await axios.patch(`/members/growing_seasons/${id}`, updateParams)
    dispatch(fetchGrowingSeasons())
    return response
  }
}

export function deleteGrowingSeason(id) {
  return (dispatch, getState) => {
    dispatch({
      type: 'GROWING_SEASON_DELETE',
      payload: axios.delete(`/members/growing_seasons/${id}`)
    })
  }
}

function markGrowingSeasonUpdating(id) {
  return {
    type: 'GROWING_SEASON_MARK_UPDATING',
    payload: id,
  }
}

export function ConvertGrowingSeasonDetailModelData(growingSeason,homeLocationCoords) {
  const seasonLocation = growingSeason.location_coords
  const isHome = !!homeLocationCoords && !!seasonLocation &&
    homeLocationCoords.lat === seasonLocation.lat && homeLocationCoords.lng === seasonLocation.lng
  const locationStr = !seasonLocation || isHome ? "" : `${seasonLocation.lat.toFixed(14)},${seasonLocation.lng.toFixed(14)}`


  return {
    name: growingSeason.name,
    sowingDate: growingSeason.sowing_date ? DateTime.fromISO(growingSeason.sowing_date) : null,
    emergenceDateOption: growingSeason.emergence_date_option,
    emergenceDate: growingSeason.emergence_date ? DateTime.fromISO(growingSeason.emergence_date) : null,
    floralInitiationDateOption: growingSeason.floral_initiation_date_option,
    floralInitiationDate: growingSeason.floral_initiation_date ? DateTime.fromISO(growingSeason.floral_initiation_date) : null,
    harvestDateOption: growingSeason.harvest_date_option,
    harvestDate: growingSeason.harvest_date ? DateTime.fromISO(growingSeason.harvest_date) : null,
    locationOption: isHome ? "home" : "custom",
    location:locationStr,
    remoteId: growingSeason.remote_id,
  }
}

export function GrowingSeasonDetailModelDefaultData(){
  return {
    name: '',
    sowingDate: null,
    emergenceDateOption: 'auto_calculate',
    emergenceDate: null,
    floralInitiationDateOption: 'auto_calculate',
    floralInitiationDate: null,
    harvestDateOption: 'not_yet_known',
    harvestDate: null,
    locationOption: 'home',
    location: '',
    remoteId: '',
  }
}

export const LocationStrReg = /-?\d+.\d+,\s*-?\d+.\d+/g

export function IsGrowingSeasonLocationValid(location){
  if (location.match(LocationStrReg)) {
    var latlng = location.match(/-?\d+.\d+/g).map(Number);

    if (latlng[0] >= -38.2 && latlng[0] <= -32.8 && latlng[1] >= 137.8 && latlng[0] <= 141.2) {
      return true;
    }
  }
  return false;
}

export function ConvertGrowingSeasonUpdateParams(activeGrowingSeason){
  const updateParams = {}
    updateParams['name'] = activeGrowingSeason['name']
    if (activeGrowingSeason['locationOption'] === 'custom') {
      var _location = activeGrowingSeason['location'].split(",")
      updateParams['location'] = {
        lat:parseFloat(_location[0]),
        lng:parseFloat(_location[1]),
      }
    }
    const dateKeysArraysArray = [
      ['sowingDate','sowing_date'],
      ['emergenceDate','emergence_date'],
      ['floralInitiationDate','floral_initiation_date'],
      ['harvestDate','harvest_date']
    ]
    dateKeysArraysArray.forEach((dateKeysArray) => {
      if (activeGrowingSeason[dateKeysArray[0]]) {
        updateParams[dateKeysArray[1]] = activeGrowingSeason[dateKeysArray[0]].toISO()
      }
    })
    const dateOptionKeysArraysArray = [
      ['emergenceDateOption','emergence_date_option'],
      ['floralInitiationDateOption','floral_initiation_date_option'],
      ['harvestDateOption','harvest_date_option'],
      ['locationOption','location_option'],
    ]
    dateOptionKeysArraysArray.forEach((dateOptionKeysArray) => {
      if (activeGrowingSeason[dateOptionKeysArray[0]]) {
        updateParams[dateOptionKeysArray[1]] = activeGrowingSeason[dateOptionKeysArray[0]]
      }
    })

    return updateParams;
}
